import { Stack, StackProps, styled } from '@mui/material';

export const Root = styled((props: StackProps) => <Stack alignItems="flex-start" gap={4} {...props} />)(
  ({ theme }) => ({
    padding: theme.spacing(8),
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
  })
);
